(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.SureLc",
                {
                    url: "/SureLc",
                    component: "surelc",
                    PageTitle: "Sure LC",
                    requiredPermissions: "SureLc:Access",
                    resolve: {
                        onBehalfOfUserGroup: ["userApi", "permissionService", "userGroupApi", function (userApi, permissionService, userGroupApi) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).then(function (user) {
                                    if (user.UserGroupId)
                                        return userGroupApi.get(user.UserGroupId);
                                    return null;
                                });
                            return null;
                        }],
                        onBehalfOfLogo: ["userGroupApi", "onBehalfOfUserGroup", function (userGroupApi, onBehalfOfUserGroup) {
                            if (onBehalfOfUserGroup)
                                return userGroupApi.getLogo(onBehalfOfUserGroup.Id).then(function (logo) {
                                    return URL.createObjectURL(logo);
                                }).catch(ng.noop);
                            return null;
                        }]
                    }
                });
        }
    ]);

    app.component("surelc",
        {
            templateUrl: "App/Tools/SureLc/surelc.html",
            controller: sureLcCtrl,
            bindings: {
                userGroup: "<",
                onBehalfOfUserGroup: "<",
                logo: "<",
                onBehalfOfLogo: "<"
            }
        });

    sureLcCtrl.$inject = ["ssoApi", "$mdDialog", "$scope", "externalLoading"];


    function sureLcCtrl(ssoApi, $mdDialog, $scope, externalLoading) {

        var $ctrl = this;

        $ctrl.userGroup = $ctrl.onBehalfOfUserGroup || $ctrl.userGroup;
        $ctrl.logo = $ctrl.onBehalfOfLogo || $ctrl.logo;       
      
        this.ActivateSureLcSso = function () {
            var w = window.open();           
            w.document.write(externalLoading.html);    
            
            ssoApi.initiateSureLcSso().then(function (data) {
                //console.log(data);
                w.document.write(data);
                w.document.forms.surelc.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        };

        $scope.$on("$destroy",
            function () {
                if ($ctrl.onBehalfOfLogo)
                    URL.revokeObjectURL($ctrl.onBehalfOfLogo);
            });

    }

})(window.app, window.angular); // jshint ignore:line